import style from './style.module.scss';
import { ReactComponent as Fb } from '../../assets/fb-ico.svg';
import { ReactComponent as Twitter } from '../../assets/twitter-ico.svg';
import { ReactComponent as Mail } from '../../assets/mail-ico.svg';
import clsx from 'clsx';

export const ShareSocials = ({ title = '', vertical = false, positionStyle }) => {
    return (
        <div className={clsx(style.socials, vertical && style.vertical, positionStyle)}>
            <a
                target={'_blank'}
                rel="noreferrer noopener"
                href={'http://www.facebook.com/sharer/sharer.php?u=' + window.location + '&t=' + title}
                className={style.social}
            >
                <Fb />
            </a>
            <a
                target={'_blank'}
                rel="noreferrer noopener"
                href={'http://www.twitter.com/share?url=' + window.location}
                className={style.social}
            >
                <Twitter />
            </a>
            <a
                target={'_blank'}
                rel="noreferrer noopener"
                href={"mailto:?body=Regarde, j'ai trouvé un article qui pourrait te plaire: " + window.location}
                className={style.social}
            >
                <Mail />
            </a>
        </div>
    );
};
